// src/services/ProductService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  where,
  query,
  Timestamp,
} from "firebase/firestore";
import { Product, ProductPrice } from "@visitproof/types";
import { db } from "../firebase";
import { clean } from "../utils/utils";

const productCollectionRef = collection(db, "products");
const pricesCollectionRef = collection(db, "prices");

export const ProductService = {
  async getProduct(productId: string): Promise<Product | null> {
    const productDoc = await getDoc(doc(productCollectionRef, productId));
    if (productDoc.exists()) {
      return { id: productDoc.id, ...productDoc.data() } as Product;
    }
    return null;
  },

  async getAllProducts(accountId: string): Promise<Product[]> {
    try {
      const productSnapshot = await getDocs(
        query(productCollectionRef, where("accountId", "==", accountId)),
      );
      return productSnapshot.docs.map(
        (doc) => ({ id: doc.id, ...doc.data() }) as Product,
      );
    } catch (err) {
      console.error(err);
      return [];
    }
  },

  async getPricesForProduct(productId: string): Promise<ProductPrice[]> {
    const paymentSnapshot = await getDocs(
      query(pricesCollectionRef, where("product", "==", productId)),
    );
    return paymentSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as ProductPrice,
    );
  },

  async updateProduct(
    productId: string,
    updatedData: Partial<Omit<Product, "id" | "createdAt">>,
  ): Promise<void> {
    const productDocRef = doc(productCollectionRef, productId);
    await updateDoc(productDocRef, clean({
      ...updatedData,
      updatedAt: Timestamp.now(),
    }));
  },

  async deleteProduct(productId: string): Promise<void> {
    const productDocRef = doc(productCollectionRef, productId);
    await deleteDoc(productDocRef);
  },
};
